query GetTaskDisplayCount($leadId: ID!) {
    lead(id: $leadId) {
        id
        name
        tasks {
            id
            isCompleted
        }
    }
}
